module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-sys-32bd7c34f05f98b2f8defa3b0bbfefba.png";